import { VaultedSecretAccess } from "@p0security/integrations-vaulted-credential-shared/accesses";
import { Access } from "@p0security/shared/types/access/index";

export const LookerAiLevels = ["read", "edit"] as const;

export const LookerAiAccesses = {
  model: Access({
    description:
      "Access to a LookML model, granted through a Looker service account created for the grant",
    label: "Model",
    maturity: "preview",
    ...VaultedSecretAccess,
    generated: {
      ...VaultedSecretAccess.generated,
      // Where the grant's MCP server signs in. The gateway fills in a server's
      // settings from the request alone, so the instance's URL is staged with
      // the grant.
      baseUrl: { type: "string", label: "Instance URL" },
    },
    parameters: {
      instance: {
        type: "dynamic",
        label: "Instance",
        description: "Looker instance",
      },
      model: {
        type: "dynamic",
        label: "Model",
        description: "LookML model",
      },
      level: {
        type: "static",
        label: "Level",
        description: "Level of access to grant on the model",
        choices: LookerAiLevels,
      },
      // Each grant gets a Looker service account of its own, deleted when the
      // grant ends. Generated, so no requestor can name an existing account.
      accountName: {
        type: "generated",
        label: "Looker service account",
        description:
          "Name of the Looker service account that P0 creates for this grant",
      },
    },
    render: {
      locator: "instance",
      policy: "level",
      resource: "model",
    } as const,
  }),
};

export type LookerAiAccesses = typeof LookerAiAccesses;
